<template>
  <div>
    <div class="btn-box">
      <div>
        <el-button size="small" @click="addRichText" :disabled="disabled"
          >添加 Markdown</el-button
        >
        <el-button
          size="small"
          @click="customComponentVisible = true"
          :disabled="disabled"
          >添加自定义控件</el-button
        >
      </div>
      <slot name="go-project"></slot>
    </div>
    <div class="page-template">
      <div
        class="page-template-item mb-12"
        v-for="(item, index) in pageTemplate"
        :key="item.tid"
      >
        <div class="item-float-delete">
          <el-link
            icon="el-icon-delete"
            :underline="false"
            type="danger"
            @click="deleteTemplate(index)"
            :disabled="disabled"
          ></el-link>
        </div>

        <template v-if="item.type === 'text'">
          <Markdown
            :ref="item.ref"
            :value.sync="item.content.html"
            :defaultOpen="defaultOpen"
            :disabled="disabled"
            video
            space="_for_plus_sub_project"
            folder="admin"
          ></Markdown>
        </template>

        <template v-if="item.type === 'homework'">
          <img src="@/assets/images/project.png" width="100%" />
        </template>

        <template v-if="item.type === 'code'">
          <OnlineCoding
            :language="item.content.language"
            :input-code.sync="item.content.input"
            :output-code.sync="item.content.output"
            :answer.sync="item.content.answer"
            :explain.sync="item.content.explain"
            :projectId="item.content.projectId"
            :disabled="disabled"
          ></OnlineCoding>
        </template>
      </div>
    </div>

    <el-dialog
      title="添加自定义控件"
      :visible.sync="customComponentVisible"
      width="500px"
      :append-to-body="true"
      @close="resetData"
    >
      <el-select v-model="customComponentValue">
        <el-option
          v-for="item in customComponentOption"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        v-if="customComponentValue == 4"
        placeholder="请选择编程语言"
        class="ml-12"
        v-model="codinglLanguage"
      >
        <el-option label="Python" value="python"></el-option>
        <el-option label="Mysql" value="mysql"></el-option>
        <el-option label="java" value="java"></el-option>
        <el-option label="node" value="node"></el-option>
        <el-option label="c++" value="c++"></el-option>
      </el-select>
      <el-select
        v-if="customComponentValue === 4"
        class="mt-12"
        placeholder="请选择文件集"
        v-model="codingFileId"
        remote
        filterable
        :remote-method="remoteMethod"
        :loading="fileSearchLoading"
      >
        <el-option
          v-for="(item, index) in codingFileList"
          :key="index"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="customComponentVisible = false">取 消</el-button>
        <el-button type="primary" @click="addCustomComponent">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Markdown from "@/components/Markdown";
import OnlineCoding from "@/components/OnlineCoding";
import projectService from "@/global/service/project";

let tid = 1000000;

export default {
  components: {
    Markdown,
    OnlineCoding
  },
  props: {
    pageTemplate: {
      type: Array,
      default: () => []
    },
    defaultOpen: {
      type: String,
      default: "edit"
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      customComponentVisible: false,
      customComponentValue: null,
      codinglLanguage: null,
      customComponentOption: [
        { value: 3, label: "项目提交控件" },
        { value: 4, label: "在线编程控件" }
      ],
      codingFileName: null,
      codingFileId: null,
      fileSearchLoading: false,
      codingFileList: []
    };
  },
  created() {
    this.getCodingFileList();
  },
  methods: {
    resetData() {
      this.customComponentValue = null;
      this.codinglLanguage = null;
      this.codingFileId = null;
    },
    getCodingFileList() {
      projectService
        .searchCodingFileList({
          name: this.codingFileName
        })
        .then(res => {
          this.codingFileList = res;
        })
        .finally(() => {
          this.fileSearchLoading = false;
        });
    },
    remoteMethod(query) {
      this.fileSearchLoading = true;
      this.codingFileName = query;
      this.getCodingFileList();
    },
    deleteTemplate(index) {
      this.pageTemplate.splice(index, 1);
    },
    addRichText() {
      let data = {
        type: "text",
        content: {
          html: ""
        },
        tid
      };
      this.pageTemplate.push(data);
      tid++;
    },
    addCustomComponent() {
      switch (this.customComponentValue) {
        case 3:
          this.pageTemplate.push({ type: "homework", content: { a: 1 }, tid });
          tid++;
          this.customComponentVisible = false;
          break;
        case 4:
          this.pageTemplate.push({
            type: "code",
            content: {
              language: this.codinglLanguage,
              input: "",
              output: null,
              answer: "",
              explain: null,
              projectId: this.codingFileId
            },
            tid
          });
          tid++;
          this.codinglLanguage = null;
          this.customComponentValue = null;
          this.customComponentVisible = false;
          this.codingFileId = null;
          break;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.btn-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 12px auto;
  width: 970px;
}
.page-template {
  text-align: center;
  .page-template-item {
    position: relative;
    display: inline-block;
    width: 100%;
    .item-float-delete {
      z-index: 1501;
      position: absolute;
      bottom: 8px;
      right: 12px;
      height: 0;
      overflow: hidden;
      .el-link {
        font-size: 16px;
      }
    }
    &:hover .item-float-delete {
      height: 22px;
    }
  }
}
</style>
